// Configuración de autenticación para diferentes ambientes
const isDevelopment = import.meta.env.NODE_ENV === 'development';
const isLocalhost = window.location.hostname === 'localhost';

// URLs base según el ambiente
const getBaseUrl = () => {
  if (isDevelopment || isLocalhost) {
    return 'http://localhost:3000';
  }
  return window.location.origin;
};

// Configuración de OAuth/SAML - OKTA INTEGRATION
export const authConfig = {
  // Configuración de Cognito Hosted UI (DOMINIO REAL DE OKTA)
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || 'us-east-1qpqyfdxjk.auth.us-east-1.amazoncognito.com',
  
  // URLs de callback
  redirectSignIn: [
    `${getBaseUrl()}/auth/callback`
  ],
  
  redirectSignOut: [
    `${getBaseUrl()}/login`
  ],
  
  // Proveedor SAML - OKTA ESPECÍFICO
  samlProvider: import.meta.env.VITE_SAML_PROVIDER || 'LLA-CES-OKTA',
  
  // Scopes OAuth
  scopes: ['email', 'openid', 'profile'],
  
  // Tipo de respuesta
  responseType: 'code',
  
  // Configuración específica de Okta
  okta: {
    enabled: true,
    buttonText: 'Sign in with Okta',
    companyName: 'Liberty Latin America',
    description: 'Use your corporate credentials to access the CES Portal'
  }
};

// Configuración de desarrollo para testing
export const devConfig = {
  enableMockAuth: import.meta.env.VITE_USE_MOCK_DATA === 'true',
  mockUser: {
    username: import.meta.env.VITE_MOCK_USERNAME || 'test.user@lla.com',
    groups: import.meta.env.VITE_MOCK_GROUPS ? import.meta.env.VITE_MOCK_GROUPS.split(',') : ['CES_ADMIN', 'CES_USER']
  },
  logLevel: import.meta.env.VITE_LOG_LEVEL || 'debug'
};

// Función para obtener la configuración completa de AWS - VALORES REALES
export const getAwsConfig = () => ({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID || 'us-east-1_QpQyfDXJK',
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '6n7nnvvof4ujj17nicbr8mi8g7',
      loginWith: {
        email: true, // Mantener login directo como fallback
        oauth: {
          domain: authConfig.cognitoDomain,
          scopes: authConfig.scopes,
          redirectSignIn: authConfig.redirectSignIn,
          redirectSignOut: authConfig.redirectSignOut,
          responseType: authConfig.responseType,
          providers: [authConfig.samlProvider]
        }
      }
    }
  }
});

export default authConfig;
